/**
 * @generated SignedSource<<1e2a404018a855dd6db8864b2af5e5fa>>
 * @relayHash 222c6cbd9725abb2c8498135788f422a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 21e52966fb7b1fdd9c3afd1de64070e1b83d5c73c8fb31fa62c895a6ca04053f

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEligibleForContextualCollabOnboardingContentContributorsQuery$variables = {
  contentId: string;
};
export type useIsEligibleForContextualCollabOnboardingContentContributorsQuery$data = {
  readonly contentContributors: {
    readonly isCurrentUserContributor: boolean | null | undefined;
  } | null | undefined;
};
export type useIsEligibleForContextualCollabOnboardingContentContributorsQuery = {
  response: useIsEligibleForContextualCollabOnboardingContentContributorsQuery$data;
  variables: useIsEligibleForContextualCollabOnboardingContentContributorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentContributors",
    "kind": "LinkedField",
    "name": "contentContributors",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "222c6cbd9725abb2c8498135788f422a",
    "id": "21e52966fb7b1fdd9c3afd1de64070e1b83d5c73c8fb31fa62c895a6ca04053f",
    "metadata": {},
    "name": "useIsEligibleForContextualCollabOnboardingContentContributorsQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForContextualCollabOnboardingContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
  }
};
})();

(node as any).hash = "ffb84dbb2774981b29c29e7117a0cf7c";

export default node;
